<div class="fcu-list-container" (click)="selectFcu()">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-fcu-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.page-title.fcu" | translate }}
            {{ " " + fcuIndex }}
        </div>
        <div class="location-container">
            <mat-icon svgIcon="more-info-status" />
        </div>
    </div>
</div>
